// extracted by mini-css-extract-plugin
export var label = "_ew-5";
export var slideContainer = "_ew-0";
export var slider = "_ew-1";
export var sliderLg = "_ew-4";
export var sliderMd = "_ew-3";
export var sliderSm = "_ew-2";